import { Documents } from "@/components/documents";
import { useAuth } from "@/hooks/use-auth";
import type { VehiclePanelBaseProps } from "../../shared";

export function VehicleDocuments({ vehicleId }: VehiclePanelBaseProps) {
	/** Hooks */
	const { organization } = useAuth();

	/** Computed */
	// `Vehicle` binds on the organisation alone, and a vehicle this page can open is the caller's
	// organisation's by construction — the connection reaches no other — so the shape is the id and
	// the active organisation, without loading the row a second time.
	const orgId = organization.orgId;
	const parent = orgId
		? { subject: "Vehicle" as const, resource: { id: vehicleId, orgId } }
		: undefined;

	/** Render */
	return (
		<Documents
			identifier={vehicleId}
			documentFilesTable="vehicleDocumentFiles"
			parent={parent}
		/>
	);
}
